// @ts-ignore
import Cookies from 'js-cookie';
var ScrollPositionPreference = /** @class */ (function () {
    function ScrollPositionPreference(HorizontalScrolling) {
        this.HorizontalScrolling = HorizontalScrolling;
        this.timeout = 0;
        this.scrolling = false;
        this.offset = 0;
        this.init();
        this.initPosition();
    }
    ScrollPositionPreference.prototype.init = function () {
        var _this = this;
        window.addEventListener('beforeunload', function () { return _this.storeCurrentPosition(); });
    };
    ScrollPositionPreference.prototype.getCacheKey = function () {
        return "hsoffset_" + AC.list_screen + "_" + AC.layout;
    };
    ScrollPositionPreference.prototype.storeCurrentPosition = function () {
        var inFiveSeconds = new Date(new Date().getTime() + 5 * 1000);
        Cookies.set(this.getCacheKey(), this.HorizontalScrolling.getScrollLeft(), {
            expires: inFiveSeconds
        });
    };
    ScrollPositionPreference.prototype.initPosition = function () {
        var _this = this;
        var scrollLeft = Cookies.get(this.getCacheKey());
        if (scrollLeft) {
            setTimeout(function () { return _this.HorizontalScrolling.setScrollLeft(scrollLeft); }, 100);
        }
    };
    return ScrollPositionPreference;
}());
export default ScrollPositionPreference;
